import { useEffect, useRef } from "react";

type PacketData = Record<string, [{ ts: string; value: string }]>;
type ParsedData = Record<string, PacketData>;
type PopulateLogicType = { divide_by?: number; unit?: string; show_time_on_hover?: boolean };
type SvgDataMapType = Record<
  string,
  {
    key: string;
    device_id: string;
    populate_element?: (
      element: HTMLElement,
      data: PacketData | ParsedData,
      key: string,
      config: PopulateLogicType,
    ) => void;
  } & PopulateLogicType
>;
type Props = {
  data: Record<string, PacketData>;
  data_map: SvgDataMapType;
  gear_type: string;
  Component: React.FC<
    React.SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >;
};
const CircuitViewSVGPopulator: React.FC<Props> = (props) => {
  const svg_ref = useRef<SVGSVGElement | null>(null);
  const { data = {}, data_map, Component } = props;
  useEffect(() => {
    const svg_component = svg_ref.current;
    if (!svg_component) return;
    for (const svg_element_id in data_map) {
      const element = svg_component.getElementById(svg_element_id) as HTMLElement;
      const populate_logic = data_map[svg_element_id];
      const device_id = populate_logic.device_id;
      const device_data = data[device_id];

      if (!element) {
        console.error("SVG_ELEMENT_NOT_FOUND_FOR_ID", svg_element_id);
        continue;
      }

      if (!device_data) {
        if (!device_id && populate_logic.populate_element) {
          populate_logic.populate_element(element, data, populate_logic.key, populate_logic);
          continue;
        }

        console.error("DEVICE_DATA_NOT_FOUND_TO_POPULATE_SVG", device_id);
        continue;
      }

      if (populate_logic.populate_element) {
        populate_logic.populate_element(element, device_data, populate_logic.key, populate_logic);
      }
    }
  }, [data]);

  return <Component ref={svg_ref} />;
};

export default CircuitViewSVGPopulator;
